import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  products: [],
  product: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    getAllProducts: (state, action) => {
      state.products = action.payload;
    },
    getProduct: (state, action) => {
      state.product = action.payload;
    },
    deleteProductById: (state, action) => {
      const filterProducts = state.products.filter(
        (e) => e.uuid !== action.payload
      );
      state.products = filterProducts;
    },
  },
});

export const dashboardActions = dashboardSlice.actions;
export const selectDashboard = (state) => state.dashboard;
export default dashboardSlice.reducer;
